import { create } from "zustand";
import { CallProtectIndicatorSchema } from "@/clients/spp";

interface CallProtectStoreInterface {
    callProtectIndr: CallProtectIndicatorSchema;
    setCallProtectIndr: (callProtectIndr: CallProtectIndicatorSchema) => void;
    deltaCallProtectPatchIndr: CallProtectIndicatorSchema; // This is used to store the changes made to the Call Protect settings, so that we can call api only if value is different from the original value
    setDeltaCallProtectPatchIndr: (deltaCallProtectPatchIndr: CallProtectIndicatorSchema) => void;
    callProtectFailed: boolean;
    setCallProtectFailed: (callProtectFailed: boolean) => void;
}

const useCallProtectStore = create<CallProtectStoreInterface>((set) => ({
    callProtectIndr: CallProtectIndicatorSchema.N,
    setCallProtectIndr: (callProtectIndr: CallProtectIndicatorSchema) => set({ callProtectIndr }),
    deltaCallProtectPatchIndr: CallProtectIndicatorSchema.N,
    setDeltaCallProtectPatchIndr: (deltaCallProtectPatchIndr: CallProtectIndicatorSchema) => set({ deltaCallProtectPatchIndr }),
    callProtectFailed: false,
    setCallProtectFailed: (callProtectFailed: boolean) => set({ callProtectFailed }),
}));

export default useCallProtectStore;
